import jwt from "jsonwebtoken"
import PropTypes from "prop-types"
import React from "react"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom"

const MenuLink = props => {
  if (props.permission) {
    let roles = []
    if (localStorage.getItem("token")) {
      roles = jwt.decode(localStorage.getItem("token"))?.roles || []
    }
    if (!roles?.some(role => props.permission.includes(role))) return null
    if (props.useRoleIds) {
      if (!props.checkRolesIds.includes(props.roleId)) {
        return null
      }
    }
  }
  return (
    <li style={{ display: props.displayNone ? "none" : "" }}>
      <Link to={props.to} className={props.className}>
        {props.icon && <i className={props.icon}></i>}
        <span>{props.t(props.label)}</span>
      </Link>
      {props.children && <ul className="sub-menu">{props.children}</ul>}
    </li>
  )
}

MenuLink.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  to: PropTypes.string.isRequired,
  permission: PropTypes.array,
  className: PropTypes.string,
  active: PropTypes.bool,
  displayNone: PropTypes.bool,
  useRoleIds: PropTypes.bool,
  roleId: PropTypes.number,
  checkRolesIds: PropTypes.array,
  t: PropTypes.any,
}

export default withTranslation()(MenuLink)
